module.exports = __webpack_public_path__ + "img/iglu-globe.07ecb5d7.png";